import http from "./httpService";
import { itemApi } from "./config.json";
import auth from "./authService";

export async function getItemForModal(val, id_customer) {
  const obj = { val, id_customer };
  const { data } = await http.post(itemApi + "selectModalItem.php", obj);
  return data;
}
export async function getItemBySupplier(detail, id_supplier) {
  const obj = { detail, id_supplier };
  const { data } = await http.post(itemApi + "selectItemSupplier.php", obj);
  return data;
}

export async function getDataItemSupplier(detail) {
  const obj = { detail };
  const { data } = await http.post(itemApi + "selectItemBySupplier.php", obj);
  return data;
}
export async function getItemSupplierForModal(val, id_supplier) {
  const obj = { val, id_supplier };
  const { data } = await http.post(itemApi + "selectModalItemSupplier.php", obj);
  return data;
}
export async function getItemQuotationForModal(val, detail) {
  const obj = { val, detail };
  const { data } = await http.post(
    itemApi + "selectModalItemQuotation.php",
    obj
  );
  return data;
}
export async function getItemEkstrusiForModal(val) {
  const obj = { val };
  const { data } = await http.post(
    itemApi + "selectModalItemEkstrusi.php",
    obj
  );
  return data;
}
export async function getItemQcForModal(val) {
  const obj = { val };
  const { data } = await http.post(
    itemApi + "selectModalItemQc.php",
    obj
  );
  return data;
}
export async function getItemQcPackingForModal(val) {
  const obj = { val };
  const { data } = await http.post(
    itemApi + "selectModalItemQcPacking.php",
    obj
  );
  return data;
}
export async function getItemShipmentPlanForModal(val) {
  const obj = { val };
  const { data } = await http.post(
    itemApi + "selectModalItemShipmentPlan.php",
    obj
  );
  return data;
}

export async function getAllItem(search, limit, offset, order, type) {
  const obj = { search, limit, offset, order, type };
  const { data } = await http.post(itemApi + "selectAllItem.php", obj);
  return data;
}
export async function insertItem(detail) {
  const username = auth.getCurrentUser();
  const obj = { username, detail };
  const { data } = await http.post(itemApi + "insertItem.php", obj);
  return data;
}
export async function getDataDrawing(id_item, search) {
  const obj = { id_item, search};
  const { data } = await http.post(itemApi + "selectDataDrawing.php", obj);
  return data;
}
export async function getDataDrawingCustomer(id_item, search) {
  const obj = { id_item, search};
  const { data } = await http.post(itemApi + "selectDataDrawingCustomer.php", obj);
  return data;
}
export async function updateItem(detail) {
  const username = auth.getCurrentUser();
  const obj = { username, detail };
  const { data } = await http.post(itemApi + "updateItem.php", obj);
  return data;
}

export async function updateItemProduction(detail, status) {
  const username = auth.getCurrentUser();
  const obj = { username, detail, status };
  const { data } = await http.post(itemApi + "updateItemProduction.php", obj);
  return data;
}
export async function updateMonitorItem(
  detail,
  image,
  fabrikasi,
  supporting,
  currSupporting,
  packing,
  currPacking
) {
  const username = auth.getCurrentUser();
  const obj = {
    username,
    detail,
    image,
    fabrikasi,
    supporting,
    currSupporting,
    packing,
    currPacking
  };
  const { data } = await http.post(itemApi + "updateMonitorItem.php", obj);
  return data;
}
export async function updateItemPenjualan(detail, fabrikasi) {
  const username = auth.getCurrentUser();
  const obj = { username, detail, fabrikasi };
  const { data } = await http.post(itemApi + "updateItemPenjualan.php", obj);
  return data;
}

export async function deleteItem(id_item) {
  const obj = { id_item };
  const { data } = await http.post(itemApi + "deleteItem.php", obj);
  return data;
}

export async function getItemById(id_item) {
  const obj = { id_item };
  const { data } = await http.post(itemApi + "selectoneItem.php", obj);
  return data;
}
export async function getQCGroupById(id_qc_group) {
  const obj = { id_qc_group };
  const { data } = await http.post(itemApi + "selectoneQCGroup.php", obj);
  return data;
}
export async function getQCGroupReport(detail) {
  const obj = { detail };
  const { data } = await http.post(itemApi + "selectQcGroupReport.php", obj);
  return data;
}

export async function getDataReportQc(search, limit, offset, order, type) {
  const obj = { search, limit, offset, order, type };
  const { data } = await http.post(itemApi + "selectDataReportQC.php", obj);
  return data;
}
export async function getQCSurfaceById(id_qc_group) {
  const obj = { id_qc_group };
  const { data } = await http.post(itemApi + "selectoneQCSurface.php", obj);
  return data;
}
export async function getQCSurfaceReport(detail) {
  const obj = { detail };
  const { data } = await http.post(itemApi + "selectQcSurfaceReport.php", obj);
  return data;
}
export async function getQCPackingById(id_qc_group) {
  const obj = { id_qc_group };
  const { data } = await http.post(itemApi + "selectoneQCPacking.php", obj);
  return data;
}

export async function insertExcelItem(path, fileName) {
  const { data } = await http.post(
    itemApi + "insertItemExcel.php?q1=" + path + "&q2=" + fileName
  );
  return data;
}

export async function updateItemQC(detail, titik, currTitik) {
  const obj = { detail, titik, currTitik };
  const { data } = await http.post(itemApi + "updateItemQC.php", obj);
  return data;
}
export async function updateItemQCPacking(detail) {
  const obj = { detail };
  const { data } = await http.post(itemApi + "updateItemQCPacking.php", obj);
  return data;
}
export async function getDataItemQC(search, limit, offset, order, type) {
  const obj = { search, limit, offset, order, type };
  const { data } = await http.post(itemApi + "selectDataItemQC.php", obj);
  return data;
}
export async function getHistoryQCItem(search, id_item) {
  const obj = {
    search,
    id_item
  };
  const { data } = await http.post(
    itemApi + "selectHistoryQCItem.php",
    obj
  );
  return data;
}

export async function getHistoryQCPacking(search, id_item) {
  const obj = {
    search,
    id_item
  };
  const { data } = await http.post(
    itemApi + "selectHistoryQCPacking.php",
    obj
  );
  return data;
}

export async function getQCItemById(id_qc_item) {
  const obj = { id_qc_item };
  const { data } = await http.post(itemApi + "selectoneQCItem.php", obj);
  return data;
}


export async function getDataItemQCPacking(search, limit, offset, order, type) {
  const obj = { search, limit, offset, order, type };
  const { data } = await http.post(itemApi + "selectDataItemQCPacking.php", obj);
  return data;
}
export async function updateQcGroup(header) {
  const username = auth.getCurrentUser();
  const obj = { username, header };
  const { data } = await http.post(itemApi + "updateQcGroup.php", obj);
  return data;
}



// WEBPACK FOOTER //
// ./src/services/itemServices.js